import { Link } from 'react-router-dom';
import { Building2, Layers, Mail, Star, Settings, ArrowRight } from 'lucide-react';
import { useNotifications } from '../NotificationContext';

const CARDS = [
  {
    to: '/admin/projects',
    icon: Building2,
    label: 'Projeler',
    desc: 'Projeleri listele, düzenle, yayınla ve sırala',
    badgeKey: null,
  },
  {
    to: '/admin/services',
    icon: Layers,
    label: 'Hizmetler',
    desc: 'Hizmet kartlarını yönet',
    badgeKey: null,
  },
  {
    to: '/admin/messages',
    icon: Mail,
    label: 'Mesajlar',
    desc: 'İletişim formu mesajları',
    badgeKey: 'messages',
  },
  {
    to: '/admin/dream-requests',
    icon: Star,
    label: 'Hayalim Talepleri',
    desc: 'Dreams sayfasından gelen proje talepleri',
    badgeKey: 'dreams',
  },
  {
    to: '/admin/company-info',
    icon: Settings,
    label: 'Şirket Bilgileri',
    desc: 'Telefon, adres, çalışma saatleri, logo ve favicon',
    badgeKey: null,
  },
];

function NotificationBanner({ messages, dreams }) {
  const total = messages + dreams;
  if (!total) return null;

  return (
    <div className="mb-6 bg-[#c5a059]/[0.07] border border-[#c5a059]/25 rounded-xl px-5 py-4">
      <p className="text-[#c5a059] text-sm font-semibold mb-2">
        {total} okunmamış bildirim
      </p>
      <div className="flex flex-wrap gap-3">
        {messages > 0 && (
          <Link
            to="/admin/messages"
            className="flex items-center gap-2 text-sm text-white/70 hover:text-white transition-colors"
          >
            <Mail size={14} className="text-[#c5a059]" />
            <span>{messages} okunmamış mesaj</span>
            <ArrowRight size={12} className="text-white/30" />
          </Link>
        )}
        {dreams > 0 && (
          <Link
            to="/admin/dream-requests"
            className="flex items-center gap-2 text-sm text-white/70 hover:text-white transition-colors"
          >
            <Star size={14} className="text-[#c5a059]" />
            <span>{dreams} okunmamış hayalim talebi</span>
            <ArrowRight size={12} className="text-white/30" />
          </Link>
        )}
      </div>
    </div>
  );
}

export default function DashboardPage() {
  const { messages, dreams } = useNotifications();

  return (
    <div className="p-4 md:p-8">
      <div className="mb-6">
        <h1 className="text-xl font-bold text-white tracking-tight">Dashboard</h1>
        <p className="text-white/35 text-sm mt-1">Ober Yapı Yönetim Paneli</p>
      </div>

      <NotificationBanner messages={messages} dreams={dreams} />

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4">
        {CARDS.map(({ to, icon: Icon, label, desc, badgeKey }) => {
          const count = badgeKey ? (badgeKey === 'messages' ? messages : dreams) : 0;
          return (
            <Link
              key={to}
              to={to}
              className="group bg-[#111] border border-white/[0.07] rounded-xl p-6 hover:border-[#c5a059]/30 hover:bg-[#c5a059]/[0.03] transition-all duration-200"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="relative w-9 h-9 rounded-xl bg-[#c5a059]/10 border border-[#c5a059]/20 flex items-center justify-center">
                  <Icon size={16} className="text-[#c5a059]" />
                  {count > 0 && (
                    <span className="absolute -top-1.5 -right-1.5 min-w-[16px] h-4 flex items-center justify-center rounded-full bg-[#c5a059] text-black text-[9px] font-bold px-1 leading-none">
                      {count > 99 ? '99+' : count}
                    </span>
                  )}
                </div>
                <ArrowRight
                  size={15}
                  className="text-white/15 group-hover:text-[#c5a059]/50 group-hover:translate-x-0.5 transition-all"
                />
              </div>
              <h3 className="text-white font-semibold text-sm mb-1">{label}</h3>
              <p className="text-white/35 text-xs leading-relaxed">{desc}</p>
              {count > 0 && (
                <p className="mt-2 text-[#c5a059] text-xs font-medium">
                  {count} okunmamış
                </p>
              )}
            </Link>
          );
        })}
      </div>
    </div>
  );
}
